import { css } from 'lit-element';

const sharedStyles = css`
  * {
    box-sizing: border-box;
  }
`;

export default sharedStyles;
